type Config = { onSuccess?: (reg: ServiceWorkerRegistration) => void; onUpdate?: (reg: ServiceWorkerRegistration) => void; };

export function register(config?: Config) {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`, { scope: '/vanijya/' })
        .then((reg) => {
          reg.onupdatefound = () => {
            const worker = reg.installing;
            if (!worker) return;
            worker.onstatechange = () => {
              if (worker.state === 'installed') {
                if (navigator.serviceWorker.controller) { config?.onUpdate?.(reg); }
                else { config?.onSuccess?.(reg); }
              }
            };
          };
        });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((reg) => reg.unregister());
  }
}
